var render = function render(_c,_vm){return _c('cta',{ref:_vm.data.ref,staticClass:"skip-main fixed",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"tag":"a","href":"#main","fill":""},on:{"click":_vm.$options.methods.click}},[_vm._v("\n  Skip to main content\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }